import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Backup as BackupIcon } from '@material-ui/icons';
import Config from 'config';
import ResourcesBox from './ResourcesBox';
import RosteringExpansionPanel, { Summary } from './RosteringExpansionPanel';
import SteppedInstructions, { Step } from './SteppedInstructions';

const BulkImport = () => {
  const classes = useStyles();
  const { t } = useTranslation('AdminRosterManagement');

  return (
    <RosteringExpansionPanel
      id="bulk-import-panel"
      square={false}
      summary={<Summary title={t('bulkImportTitle')} subtitle={t('bulkImportSubtitle')} />}
      icon={<BackupIcon className={classes.icon} />}
    >
      <Details />
    </RosteringExpansionPanel>
  );
};

const Details = () => {
  const { t } = useTranslation('AdminRosterManagement');

  const video = {
    src: `${Config.s3Url}/support/video/PLI-Bulk_Import_Spreadsheet.mp4`,
    title: t('bulkImportVideoTitle')
  };

  const resourceLinks = [
    {
      href: `${Config.s3Url}/docs/Bulk_Import_Instructions_v13.pdf`,
      label: t('bulkImportInstructionsLabel')
    },
    {
      href: `${Config.s3Url}/docs/BulkImportTemplate-8.0.xlsx`,
      label: t('bulkImportSpreadsheetLabel')
    },
    {
      href: `${Config.s3Url}/docs/BulkImportTemplate-8.0-SAMPLE.xlsx`,
      label: t('bulkImportSampleSpreadsheetLabel')
    }
  ];

  return (
    <div>
      <ResourcesBox title={t('bulkImportResources')} video={video} resourceLinks={resourceLinks} />
      <SteppedInstructions>
        <Step number={1}>
          <Typography variant="subtitle1">
            {t(
              'Read the Instructions for Bulk Import and complete the Bulk Import spreadsheet. Or, export your data into OneRoster 1.1 format directly from your Student Information System (SIS).'
            )}
          </Typography>
        </Step>
        <Step number={2}>
          <Typography variant="subtitle1">
            {t('When files are complete, send it to us using our secure link, ')}
            <a href="https://upload.lwtears.com/" target="_blank" rel="noopener noreferrer">
              https://upload.lwtears.com
            </a>
            {t(' or ')}
            <a href={Config.rosteringSupportUrl} target="_blank" rel="noopener noreferrer">
              {t('contact us')}
            </a>
            {t(' with any questions.')}
          </Typography>
        </Step>
        <Step number={3}>
          <Typography variant="subtitle1">
            {t(
              'We will upload your data. Once licenses have been assigned, we will notify you by email with next steps.'
            )}
          </Typography>
        </Step>
      </SteppedInstructions>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  icon: {
    height: 46,
    width: 46,
    margin: 'auto',
    color: theme.palette.secondary.main
  }
}));

export default BulkImport;
